export const initialState = {
  status: false
}

export const getPopoverStatus = (state, delta) => state[delta] || false


// WEBPACK FOOTER //
// ./src/interface/store/departments/popover/selectors.js